import styled from "styled-components"

import {ValidationButton as BaseValidationButton} from "@irati/ui/src/FormItem"
import {H2, H4} from "@irati/ui/src//Typography/Heading"

export const ValidationButton = styled(BaseValidationButton)`
  margin: 0px auto;
  display: block;
`

export const H2FlexGrow = styled(H2)`
  flex-grow: 1;
`

export const Wrapper = styled.div`
  ${H2}:first-letter, ${H4}:first-letter {
    text-transform: capitalize;
  }
`

export const MarginTop = styled.div`
  margin-top: 30px;
`
